export default "__VITE_ASSET___TmZb0WL__"